// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "components/DashboardNavbar";

import { create, updateById } from "services/ShowroomSubscriptionPackage";
import { useNavigate, useParams } from "react-router-dom";
import { useMaterialUIController, setErrorSB, setSuccessSB } from "context";
import { Formik } from "formik";
import * as Yup from "yup";
import useLocale from "context/useLocale";
import ShowroomSubscriptionPackageFormik from "./form";

function ShowroomSubscriptionPackageForm() {
  const locale = useLocale();
  const { id } = useParams();
  const [, dispatch] = useMaterialUIController();
  const navigate = useNavigate();

  const submitForm = async (values) => {
    if (id) {
      updateById(id, values).then(
        (res) => {
          setSuccessSB(dispatch, `${res.data.data.name} Subscription package has been updated`);
          setTimeout(() => {
            navigate("/dashboard/showroomSubscriptionPackage/");
          }, 500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    } else {
      create(values).then(
        (res) => {
          setSuccessSB(
            dispatch,
            `${res.data.data.name} Showroom Subscription Package has been created`
          );
          setTimeout(() => {
            navigate("/dashboard/showroomSubscriptionPackage/");
          }, 1500);
        },
        (err) =>
          setErrorSB(
            dispatch,
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          )
      );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {locale("showroomSubscriptionPackageForm")}
                </MDTypography>
              </MDBox>
              <MDBox p={4}>
                <Formik
                  initialValues={{
                    allowed_featured_listings_count: "",
                    allowed_listings_count: "",
                    can_manage_branches: false,
                    featured_validity_period: "",
                    is_featured_showroom: false,
                    name: "",
                  }}
                  onSubmit={async (values) => {
                    await submitForm(values);
                  }}
                  validationSchema={Yup.object().shape({
                    name: Yup.string().required("Required").min(2, "Must be at least 2 characters"),
                    allowed_listings_count: Yup.number()
                      .required("Required")
                      .min(0, "Must be a positive number"),
                    allowed_featured_listings_count: Yup.number()
                      .required("Required")
                      .min(0, "Must be a positive number")
                      .max(
                        Yup.ref("allowed_listings_count"),
                        "Cannot exceed allowed listings count"
                      ),
                    featured_validity_period: Yup.number()
                      .required("Required")
                      .min(0, "Must be a positive number"),
                    can_manage_branches: Yup.boolean().required("Required"),
                    is_featured_showroom: Yup.boolean().required("Required"),
                  })}
                >
                  <ShowroomSubscriptionPackageFormik />
                </Formik>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default ShowroomSubscriptionPackageForm;
